import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Link from "app/components/UI/Link";
import Modal from "app/components/UI/Modal";
import PropTypes from "prop-types";
import React from "react";
import classes from "./ModalCheckout.module.css";
import classnames from "classnames";

export const ModalCheckout = ({ clubId, translate, className, children, isError, onClick, ...props }) =>
  <Modal contentClassName={classnames(classes.modal, className)} bodyClassName={classes.modal__body} {...props}>
    <div className={classnames(classes.modal__title, { [classes.error]: isError })}>
      {isError
        ? translate("Aucun compte ne correspond aux informations")
        : translate("Vous ne retrouvez pas votre compte")}
    </div>
    <div className={classes.modal__content}>
      {children}

      <Flex direction="row" middle right wrap className={classes.modal__actions}>
        <Button
          className={classes.modal__action}
          onClick={onClick}
          label={translate("Modifier les informations")}
          primary
        />
        <Link className={classes.modal__link} to={formatPattern("/:clubId/shop", { clubId: clubId })}>
          <Button.Flat label={translate("Revenir à la boutique")} secondary />
        </Link>
      </Flex>
    </div>
  </Modal>;

ModalCheckout.propTypes = {
  clubId: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  isError: PropTypes.bool,
  onClick: PropTypes.func
};

export default ModalCheckout;



// WEBPACK FOOTER //
// ./src/app/components/ModalCheckout/ModalCheckout.js